import MultipleProgressBar from "../components/multipleprogressbar";
import React, { useEffect, useState } from "react";
import ProgressBar from "../components/progress1";
import axios from "axios";
import '../components/tooltip.css';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip,ResponsiveContainer,
  CartesianGrid
} from 'recharts';
import './dashboard3.css';
import { BiSort } from "react-icons/bi";
import { FaSearch } from "react-icons/fa";
import 'react-tooltip/dist/react-tooltip.css'




var color = ['blue', 'red', 'green']



function Tooltips(props) {
  const { data, children,color,total,element } = props;
  const [hover,setHover]=useState(false);
  
  
   
const[overlay,setoverLay]=useState(false)

  function getPosition(){
    
    let con=document.getElementById("con")
   
    let inner=document.getElementById(element)
    let containerRect=con.getBoundingClientRect()
    let divRect=inner.getBoundingClientRect()

    var position={
      bottom:divRect.bottom-containerRect.bottom,
      top:divRect.top-containerRect.top
    }
if(position.top>90){

  setoverLay(true)
}else{
  setoverLay(false)

}

  }
 
  
  return (
    <div  className='grey-bg'  onMouseEnter={()=>{setHover(true);getPosition()}} onMouseLeave={()=>{setHover(false)}} >
      {children}
   
     {(hover )&&<div id={"inner"} className='tooltiptext' style={{zIndex:999,top:overlay?"-75px":"30px"}} > 
      <p  className={"m-0 p-0 text-"+color[0]} >{`${data[0].label} :${data[0].value} `}</p>
      <p className={" m-0 p-0 text-"+color[1]} >{`${data[1].label} :${data[1].value}`}</p>
      <p className={" m-0 p-0 text-"+color[2]} >{`${data[2].label} :${data[2].value} `}</p>
     </div>}
    </div>
  );
}

const CustomTooltip = ({ active, payload, label }) => {

  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip p-2" style={{ backgroundColor: "black" }}>
        <p className={"label text-"+color[0]}>{`Total rows Processed : ${payload[0].value}`}</p>
        <p className={"label text-"+color[1]}>{`Failed rows : ${payload[1].value}`}</p>
        <p className={"label text-"+color[2]}>{`Overall Percent : ${payload[2].value}`}</p>

      </div>
    );
  }

  return null;
};


function Dashboard3() {
  var [search, setSearch] = useState(undefined)
  const [firstData, setFirst] = useState([])
  const [secondData, setSecondData] = useState([])
  const [thirdData, setThirdData] = useState([])
  const [fourthData, setFourthData] = useState([])
  const [completeFourthData, setCompleteFourthData] = useState([])
  const [sortOrder,setShotOrder]=useState("asc")



  const [List4,setList4]=useState([])
  useEffect(() => {
    signIN()
  }, [])



  function Search(n){
  n=n.toLowerCase()
    let searchArray=[]
    let dq=[...completeFourthData]
    if(n && n!=""){
    for(let i=0;i<dq.length;i++){
  
     dq[i]["Total rows Processed"] = dq[i]["Total rows Processed"].toString()
     dq[i]["Failed rows"] = dq[i]["Failed rows"].toString()
     dq[i]["Overall Percent"] = dq[i]["Overall Percent"].toString()
  
  
  
    
  
     if((dq[i]["Concept Source"]).toLowerCase().includes(n)){
         searchArray.push(dq[i])
        }
       else if((dq[i].Element).toLowerCase().includes(n)){
         searchArray.push(dq[i])
        }
       else if((dq[i]["Total rows Processed"]).toLowerCase().includes(n)){
         searchArray.push(dq[i])
        
        }
      else if((dq[i]["Failed rows"]).toLowerCase().includes(n)){
         searchArray.push(dq[i])
        
        }
       else if((dq[i]["Overall Percent"]).toLowerCase().includes(n)){
         searchArray.push(dq[i])
         
        }
     }
  
     setFourthData(searchArray)
    }
    else{
      setFourthData(completeFourthData)
    }
  }

  function signIN() {
    axios.post(process.env.REACT_APP_API_POINT + "auth/login", { username: "saral", password: "saral" }, { headers: { "Content-Type": "application/x-www-form-urlencoded" } }).then((data) => {
      if (data.data.success == true) {
        sessionStorage.setItem('token', data.data.access_token)
        axios.post(process.env.REACT_APP_API_POINT + 'integrify-dashboard/dq-detail-Q1', {
          "rulestype": "",

        }, { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((data, err) => {

          if (data.data.success == true) {
            data.data["DQ-DetailData-Q1"].forEach((ele) => {
              ele.bar = getArray(ele)
              ele.total = ele.bar.total
              delete ele.bar.total
            })

            setFirst(data.data["DQ-DetailData-Q1"])
          }
        })
        axios.post(process.env.REACT_APP_API_POINT + "integrify-dashboard/dq-detail-Q2", {
          "rulestype": "",
          "attribute": "",

        }, { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((d) => {
          if (d.data.success) {
            d.data["DQ-DetailData-Q2"].forEach((ele) => {
              ele.bar = getArray(ele)
              ele.total = ele.bar.total
              delete ele.bar.total
            })

            setSecondData(d.data["DQ-DetailData-Q2"])

          }
        })
        axios.post(process.env.REACT_APP_API_POINT + "integrify-dashboard/dq-detail-Q3", {
          "rulestype": "",
          "attribute": "",
          "dataqualitydimension": "",

        }, { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((d) => {
          if (d.data.success) {
            let data = []
            d.data["DQ-DetailData-Q3"].forEach((ele) => {
              let obj = {
                name: ele['Dataqualitydimension'],
                uv: ele['Total rows Processed'],
                pv: ele['Failed rows'],
                amt: ele['Overall Percent'],
              }
              data.push({ ...obj })
            })

            setThirdData(data)

          }
        })
        axios.post(process.env.REACT_APP_API_POINT + "integrify-dashboard/dq-detail-Q4", {
          "rulestype": "",
          "attribute": "",
          "dataqualitydimension": "",
          "concept_source": ""
        }, { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((d) => {
          if (d.data.success) {
            
            setList4(Object.keys(d.data["DQ-DetailData-Q4"][0]))
            setFourthData(d.data["DQ-DetailData-Q4"])
            setCompleteFourthData(d.data["DQ-DetailData-Q4"])
            

          }
        })
      }
    })
  }
  
  function sortAsc(i){
    
    let temp=[...fourthData]
console.log(temp)
    temp=temp.sort(function ( a, b ) {
      if ( a[i] < b[i] ){
        return sortOrder=='asc'? -1:1;
      }
      if ( a[i] > b[i] ){
        return sortOrder=='asc'?1:-1;
      }
      return 0;
    })
    setShotOrder(sortOrder=="asc"?"desc":"asc")
    console.log(temp,"aftertemp")
    setFourthData(temp)


}

const [width, setWidth] = useState(window.innerWidth);

const handleResize = () => {
  setWidth(window.innerWidth);
};
useEffect(() => {
  window.addEventListener('resize', handleResize);
  
  console.log(window.innerWidth);
  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);
 

  function getArray(obj) {
    let label = Object.keys(obj)
    let values = Object.values(obj)
    let output = []
    for (let i = 0; i < label.length; i++) {
      if (label[i] == 'Total rows Processed' || label[i] == 'Failed rows' || label[i] == 'Overall Percent') { output.push({ "label": label[i], "value": values[i] }) }

    }

    let b = output.reduce((a, b) => { return a + b.value }, 0)
    output.total = b

    return output
  }


  return (<>
    <div className="row  my-4 ">
      <div className="col-md-6 col-sm-12 col-xs-12   " >
        <div className="card h-100 p-3 multi-progress">
          <span className="card-title text-dark dq-label" >DQ Score By Rules</span>
          {firstData.map((data,index) => (<div className="row align-items-end d-flex ">
            <div className="col-4">
              <span className="text-dark  ">{data['Rules Type']}</span>
            </div>
            <div className="col-7" id={"con"} >
            <Tooltips data={data.bar} color={color} total={data.total} element={index} children={
                <MultipleProgressBar className="" style={{backgroundColor:'gray',padding:'15px'}}>
                  {
                    data && data.bar && data.bar.map(
                      (item, key) => (< >
                        
                        <ProgressBar

                          value={(item.value / data.total) * 100}
                          label={item.label}
                          color={color[key]} />

                      </>)
                    )
                  }
                </MultipleProgressBar>}></Tooltips>
             
            </div>
          </div>))}
        </div>
      </div>
      {/* <div class="col-md-1"></div> */}
      <div className="col-md-6 col-sm-12 col-xs-12  ">
        <div className="card h-100 p-3 multi-progress" id={"con"}>
          <span className="card-title text-dark dq-label" style={{ marginBottom: "0px" }}>DQ Score By Attribute</span>
          {secondData.map((data,index) => (<div className="row align-items-end d-flex" id={index}>
            <div className="col-4">
              <span className="text-dark" >{data['Attribute']}</span>
            </div>
            <div className="col-7"  >
              
                  <Tooltips data={data.bar} color={color} total={data.total} element={index} children={
                <MultipleProgressBar className="">
                {
                  data && data.bar && data.bar.map(
                    (item, key) => (< >
                      <ProgressBar

                        value={(item.value / data.total) * 100}
                        label={item.label}
                        color={color[key]} />

                    </>)
                  )
                }
              </MultipleProgressBar>}></Tooltips>
              
            </div>
          </div>))}
        </div>
      </div>
    </div>

    <div className="row my-3">
      <div className="col-md-12 col-sm-12">
        <div className="card py-2">
          <span className=" text-dark dq-label mx-5" >DQ Score By Data Quality Dimension</span>
          <div className={"d-flex dq-bar" } style={{height:"40rem",overflowX:"scroll",justifyContent:width>1200?"center":"",paddingLeft:"20px"}}>
          {/* <ResponsiveContainer width="100%" height={"100%"}> */}
            <BarChart  data={thirdData} width={1000} height={500} margin={{ bottom: "2" }} >
              <XAxis dataKey="name" angle={width<1200 ? -70 : -60} textAnchor="end" />
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="uv" stackId="a" fill="rgb(59, 130, 246)" />
              <Bar dataKey="pv" stackId="a" fill="#FB7073" />
              <Bar dataKey="amt" stackId="a" fill="rgb(44, 213, 192)" />
            </BarChart>
            {/* </ResponsiveContainer> */}
          </div>
        </div>
      </div>

    </div>


    <div className="bg-white topics  ">
      <div className="search py-2">
        <input type="search" className="search" placeholder="Search" onInput={(e)=>{Search(e.target.value)}}  style={{width:'30rem',width: "15rem",height: '40px',fontSize:'21px',paddingLeft: "10px"}}></input>
      </div>
      <div className="table">
      <table border={1} className="w-100" style={{borderCollapse:"unset"}}>
        <thead>
        <tr style={{backgroundColor:'#3a6ab9', color:'white', borderLeft: '3px solid #3a6ab9', borderRight: '3px solid #3a6ab9'}}>
          {List4 && List4.map((data, i) => (
            <th style={{border:'2px solid white', position:'sticky', top:'0',backgroundColor:'#3a6ab9'}}>
              <div className="d-flex justify-content-center align-items-center px-1 ">
              <span className="text-white mx-4">{data}</span>
           { <div className="text-white ">
            <BiSort onClick={()=>{sortAsc(data)}} />
            </div>}
              
            </div></th>
          ))}
        </tr>
        </thead>
        <tbody>
          
        {fourthData.map((data, index) => (
          <tr>
            { List4 && List4.map((ele, i) => (
              <td className="text-dark text-center" style={{border:'2px solid #3a6ab9', padding: '8px 15px'}}>
                { data[ele]}</td>
            ))}
          </tr>

))}
        </tbody>
      </table>
 


      </div>
    </div>

  </>
  )
}

export default Dashboard3